module.exports = __webpack_public_path__ + "static/media/techview-maroon.9b03b95d.svg";